import { Module } from 'app/library/module/models/module.model';
import { GlobalParticipant } from 'app/projects/user/src/lib/models/participant.model';
import { IParticipantExecutionChangeQuery } from '../interfaces/participant-execution-change.query.interface';

export class ParticipantExecutionChange {
    participant: GlobalParticipant;
    alreadyBooked: Module;
    selected: Module;

    constructor(query: IParticipantExecutionChangeQuery) {
        if (query) {
            this.participant = new GlobalParticipant(query.participant);
            this.alreadyBooked = new Module(query.already_booked);
            this.selected = new Module(query.selected);
        }
    }
}
